import {Injectable, Injector} from '@angular/core';
import {ComponentAsElement} from './annotation/component-as-element';
import {createCustomElement} from '@angular/elements';

@Injectable({
  providedIn: 'root'
})
export class RegisterElementService {

  constructor(private injector: Injector) {
  }

  registerElements() {
    for (const component of ComponentAsElement.components) {
      const element = createCustomElement(component.component, {injector: this.injector});
      customElements.define(component.name, element);
    }
  }
}
